<ion-grid class="contenedor-mensaje">
    <ion-row><ion-text class="titulo-mensaje">{{titulo}}</ion-text></ion-row>
    <ion-row><ion-text class="mensaje">{{mensaje}}</ion-text></ion-row>
</ion-grid>
